import React, { useEffect, useState } from 'react';
import styles from './childProducts.module.scss';
import { ReactComponent as EmptyStateImage } from 'assets/ColorIcons/SVG/group_58851.svg';
import COButton from 'shared/components/COButton';
import { AllProductsProps } from 'enums/AllProductsEnums';
import COProductCard from 'shared/components/COProductCard';
import COAlertModal from 'shared/components/COAlertModal';
import { useLocation, useParams } from 'react-router-dom';
import COPagination from 'shared/components/COPagination';
import { ButtonProps } from 'enums/ProductsViewEnums';
import CreateProductModal from 'shared/components/CreateProductModal';
import LoaderAnimation from 'shared/components/LoaderAnimation';
import DashboardContainer from 'views/Dashboard/DashboardContainer';
import { ReactComponent as BackIcon } from 'assets/icons/back_arrow.svg';
import useRedirect from 'shared/utils/useRedirect';
import { AuthContext } from 'context/AuthContext';
import { ChildProduct } from 'models/ChildProduct/childProduct.model';
import { CreateProductModalProps } from 'enums/CreateProductModalEnums';
import { notification } from 'antd';
import ProductCreationService from 'services/ProductsService/productCreation.service';
const ChildProducts = () => {
  const {
    fetchChildProducts,
    childProductList,
    deleteProduct,
    duplicateProduct,
    totalItems,
    currentPage,
    loading,
  } = ProductCreationService();
  const { user } = AuthContext();
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const productName = location.state ?? {};
  const [clickedCard, setClickedCard] = useState<number | null>(null);
  const [showModalState, setShowModalState] = useState<boolean>(false);
  const [modalType, setModalType] = useState<
    AllProductsProps.DELETE | AllProductsProps.COPY | null
  >(null);
  const [createProductModalState, setCreateProductModalState] =
    useState<boolean>(false);
  const {
    navigateBack,
    redirectToProductOverview,
    redirectToProductDistribution,
    redirectToProductFacility,
    redirectToProductRawMaterial,
    redirectToProductRawTransport,
  } = useRedirect();
  useEffect(() => {
    fetchChildProducts(productName);
  }, [productName]);

  const handleModalCancel = () => {
    setShowModalState(false);
    setClickedCard(null);
    setModalType(null);
  };

  const handleModalConfirm = async () => {
    if (modalType === AllProductsProps.DELETE && clickedCard) {
      await deleteProduct(clickedCard);
      await fetchChildProducts(productName);
    } else if (modalType === AllProductsProps.COPY && clickedCard) {
      await duplicateProduct(clickedCard);
    }
    setShowModalState(false);
    setClickedCard(null);
    setModalType(null);
    fetchChildProducts(productName);
  };

  const handleCopyModal = (value?: number) => {
    setModalType(AllProductsProps.COPY);
    setClickedCard(value || null);
    setShowModalState(true);
  };
  const handleDeleteModal = (value?: number) => {
    setModalType(AllProductsProps.DELETE);
    setClickedCard(value || null);
    setShowModalState(true);
  };

  const handleCancelCreateProductModal = () => {
    setCreateProductModalState(false);
  };

  const handleOpenCreateProductModal = () => {
    const uniqueId = childProductList && childProductList[0]?.uniqueId;
    const isNew = childProductList[0]?.isNew;
    if (uniqueId === null && !isNew) {
      notification.error({
        message: ButtonProps.Validation_Text,
        duration: 4,
      });
    } else if (uniqueId === null && isNew) {
      notification.error({
        message: ButtonProps.IS_NEW_TEXT_ERROR,
        duration: 4,
      });
    } else {
      setCreateProductModalState(true);
    }
  };

  const navigateProductOverview = (productId?: number, stage?: number) => {
    switch (stage) {
      case 4:
        redirectToProductOverview(productId);
        break;
      case 3:
        redirectToProductDistribution(productId);
        break;
      case 2:
        redirectToProductFacility(productId);
        break;
      case 1:
        redirectToProductRawTransport(productId);
        break;
      case 0:
        redirectToProductRawMaterial(productId);
        break;
      default:
        break;
    }
  };

  const handlePaginationChange = (page: number) => {
    fetchChildProducts(productName, page);
  };

  const UniqueName =
    (childProductList &&
      childProductList.length > 0 &&
      childProductList[0].name) ||
    '';
  return (
    <>
      <DashboardContainer>
        {loading ? (
          <div className={styles.loaderContainer}>
            <LoaderAnimation />
          </div>
        ) : (
          <div className={styles.topContainer}>
            <div className={styles.topLeftContainer}>
              <div className={styles.iconWrapper} onClick={navigateBack}>
                <BackIcon />
              </div>
              <h1>{UniqueName}</h1>
            </div>

            <div className={styles.topRightContainer}>
              <COButton onClick={handleOpenCreateProductModal}>
                {ButtonProps.ADD_ANOTHER_YEAR}
              </COButton>
            </div>
          </div>
        )}
        <div className={styles.PaginationContainer}>
          <COPagination
            onChange={handlePaginationChange}
            total={totalItems}
            current={currentPage}
          />
        </div>

        <CreateProductModal
          showModalState={createProductModalState}
          handleModalCancel={handleCancelCreateProductModal}
          handleModalConfirm={handleCancelCreateProductModal}
          userId={Number(user?.id)}
          isCreate
          parentProductId={childProductList?.[0]?.uniqueId?.toString()}
          heading={CreateProductModalProps.ADD_REPORTING_YEAR}
        />

        <div className={styles.verifiedProductsContainer}>
          {childProductList.length > 0 && !loading ? (
            <div className={styles.productContainer}>
              {childProductList.map((product: ChildProduct, index: number) => (
                <COProductCard
                  key={index}
                  data={product}
                  calenderRow
                  showStatus
                  multiRowCard
                  showDownloadOptions={product.status}
                  onDeleteClick={handleDeleteModal}
                  onCopyClick={handleCopyModal}
                  navigateProductOverview={navigateProductOverview}
                  isProduct={true}
                />
              ))}
            </div>
          ) : (
            <>
              {loading ? null : (
                <div className={styles.buttonContainer}>
                  <EmptyStateImage />
                  <COButton onClick={handleOpenCreateProductModal}>
                    {AllProductsProps.CREATE_PRODUCT}
                  </COButton>
                </div>
              )}
            </>
          )}
        </div>

        <COAlertModal
          handleModalCancel={handleModalCancel}
          handleModalConfirm={handleModalConfirm}
          showModalState={showModalState}
          heading={
            modalType === AllProductsProps.DELETE
              ? AllProductsProps.DELETE_PRODUCT
              : AllProductsProps.COPY_PRODUCT
          }
          subHeading={
            modalType === AllProductsProps.DELETE
              ? AllProductsProps.DELETE_SUBHEADING
              : AllProductsProps.COPY_SUBHEADING
          }
        />
      </DashboardContainer>
    </>
  );
};

export default ChildProducts;
